import { h } from "preact";

// Visualizer Panel Cards
export const VisualizerSectionCard = (data) => {
  let togglePanel = data.togglePanel,
  position = data.index,
  selections = data.state.selections && data.state.selections[data.item.id],
  selectedItems = data.state.selectedItems,
  isComplete = selectedItems && selectedItems[data.item.id] && Object.keys(selectedItems[data.item.id]).length > 0,
  isSize = data.state.selectedSizes[data.item.id] >= 0 && true,
  isError = data.state.errors && data.state.errors[data.item.id] && true,
  name = data.title ? data.title : data.item.name,
  width = data.state.selectedSizes.width,
  length = data.state.selectedSizes.length,
  sizing = data.item.id === 'artwork' && isComplete ? `${width}" x ${length}" ` : ``,
  title;

  switch (true) {
    case isError:
      title = 'Select a new option';
      break;
    case isComplete && isSize:
      let titleName = selectedItems[data.section].name ? selectedItems[data.section].name : selectedItems[data.section].title,
      titleSize = data.state.selectedSizes[data.item.id];
      title = `${titleSize}" ${titleName} ${data.item.name.toLowerCase()}`;
      break;
    case isComplete:
      title = selectedItems[data.section].name ? selectedItems[data.section].name : selectedItems[data.section].title;
      break;
    case isSize:
      title = `${data.state.selectedSizes[data.item.id]}" ${data.item.name.toLowerCase()}`;
      break;
    default:
      title='None Selected'
      break;
  }

  return (
    <div 
      className={`option-card${(isError) ? ' error': ''}${(isComplete || isSize) ? ' complete': ''}`}
      data-section={data.item.id}
      onClick={(e)=>{ togglePanel(e)}}>
      {(isComplete || isSize) && (<span className="complete"></span>)}
      {isError && (<span className="error"></span>)}
      <img src={data.item.image} alt=""/>
      <div className="option-card-content">
        <h6>{data.index && `${data.index}. `}{ name }</h6>
        <p className="selection">{sizing}<span>{`${title.substring(0 , 25)}${title.length > 25 ? '...' : ''}` }{selections && <span class="recommendation">Recommended</span>}</span></p>
        <span className="arrow arrow-right"></span>
      </div>
    </div>
  )
}

export const VisualizerProductCard = (data) => {
  let $this = data.$this,
  item = data.option,
  pkey = data.pkey,
  multiselect = data.multiselect,
  selectedItem = $this.state.selectedItem && $this.state.selectedItem[data.section],
  selectedItemInfo = $this.state.selectedItemInfo && $this.state.selectedItemInfo[data.section],
  selectedItems = $this.state.selectedItems;

  let isItems = !selectedItemInfo && selectedItems && selectedItems[data.section],
  isSelected = isItems && selectedItems[data.section].title === item.title,
  isActive = selectedItemInfo && selectedItemInfo.title === item.title;

  if (multiselect) {
    isSelected = isItems && (selectedItems[data.section][data.type] === item.title);
    isActive = selectedItem && selectedItem[data.type] ? (selectedItem[data.type] === pkey) : false;
    isActive = isActive ? isActive : selectedItemInfo && selectedItemInfo.title === item.title;
  }

  return (
    <div className={`option-card ${isActive || isSelected ? 'selected' : ''}`} onClick={(e) => {$this.selectOption(e, data, pkey, multiselect)}}>
      { data.thumbnail ? (<img src={data.thumbnail} alt=""/>) : (<img src="https://via.placeholder.com/200x270" />)}
      <div className="option-card-content">
        { item.title && (<h5>{ item.title }</h5>)}
        { item.description ? (<p className="description">{ $this.truncate(item.description) }</p>) : <p className="description">No Description Currently Present</p>}
        { item.price && (<p className="price">{`Starting at ${item.price}`}</p>)}
      </div>
    </div>
  );
}

export const VisualizerImageCard = (data) => {
  let image = data.data,
  thumb = image.display_sizes[0].uri,
  layout = image.orientation && image.orientation.toLowerCase(),
  title = image.title;

  return (
    <div className={`image-card ${layout}`} onClick={(e)=> {data.$this.setState({selectedImage: image, imageSelected: true})}}>
      <div className="image-card-content">
        <img src={thumb} alt={title}/>
        <div className="image-card-price">$35 - $95</div>
      </div>
    </div>
  );
}

export const VisualizerArtCard = (data) => {
  const Image = data.img;
  let type = data.type;

  return (
    <div className="option-card artwork" onClick={(e)=>{ type === 'getty' ? data.$this.searchImage() : data.$this.uploadImage()}}>
      <div className="option-card-content">
        { data.title && (
          <h5>
            { Image && ( Image )}
            { data.title }
            </h5>
        )}
        { data.content && (<p className="description">{ data.content }</p>)}
      </div>
    </div>
  );
}

export const VisualizerSelectedArtCard = (data) => {
  const item = data.$this.state.selectedItems[data.type];
  let uploaded = data.$this.state.selectedItems['artwork'] && data.$this.state.selectedItems['artwork'].type === 'upload';

  return (
      <div className="option-card artwork-selected">
        { item.url ? (<img src={item.url} alt=""/>) : (<img src="https://via.placeholder.com/200x270" />)}
        <div className="option-card-content">
          <h6>Image Upload</h6>
          { item.name && (<p>{ `${item.name.substring(0 , 25)}${item.name.length > 25 ? '...' : ''}` }</p>)}
          <p className="adjust">
            {uploaded ? [
              <a onClick={(e)=>{ data.$this.uploadImage()}}>Adjust Crop</a>,
              <a onClick={(e)=>{ data.$this.uploadImage(true)}}>Change Photo</a>
            ]: (
              <a onClick={(e)=>{ data.$this.searchImage()}}>Change Photo</a>
            )}
          </p>
        </div>
      </div>
  );
}